// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"67":"af491f34","91":"12f4a301","500":"f1e0595d","628":"e8691059","912":"f525a1fa","934":"b3ca9489"}[chunkId] + ".css";
};